import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "placeholder"];
  static values = { index: Number, uploadUrl: String, reload: Boolean };

  upload(event) {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.createPreview(e.target.result);
        this.dispatchUploaded();
        this.sendToServer(file);
      };
      reader.readAsDataURL(file);
    }
  }

  createPreview(imageSrc) {
    const img = document.createElement('img');
    img.src = imageSrc;
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.objectFit = 'cover';
    img.style.borderRadius = 'var(--radius-xl)';

    this.placeholderTarget.innerHTML = '';
    this.placeholderTarget.appendChild(img);
    this.placeholderTarget.style.border = 'none';
  }

  dispatchUploaded() {
    this.dispatch('uploaded', {
      detail: { index: this.indexValue }
    });
  }

  sendToServer(file) {
    if (!this.hasUploadUrlValue) return;

    const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    const formData = new FormData();
    formData.append('photo[image]', file);

    fetch(this.uploadUrlValue, {
      method: 'POST',
      headers: { 'X-CSRF-Token': token },
      body: formData,
      credentials: 'same-origin'
    })
      .then(async (res) => {
        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          throw new Error(data.error || (data.errors && data.errors.join(', ')) || 'Upload failed');
        }
        return res.json();
      })
      .then((data) => {
        this.element.dataset.photoId = data.id;
        this.element.classList.add('uploaded');
        this.dispatch('serverUploaded', { detail: data });
        // On the profile-edit screen, refresh so the new photo shows in the
        // managed grid with its Set-main / Remove controls.
        if (this.reloadValue) {
          setTimeout(() => window.location.reload(), 400);
        }
      })
      .catch((error) => {
        console.error(error);
        this.element.classList.add('upload-error');
        this.dispatch('uploadError', { detail: { message: error.message } });
      });
  }
}
